import { msg } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { titleFor } from '~/lib/route-title'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/tasks')({
  component: TasksLayout,
  head: () => ({ meta: [{ title: titleFor(msg`Tasks`) }] }),
})

// Pass-through layout: the board and the full-page task detail are child routes.
function TasksLayout() {
  return <Outlet />
}
